import React from 'react';
import {
  DateTimeRangePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { enGB } from 'date-fns/locale';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import { parseISO } from 'date-fns';

import { Tooltip } from 'components/common/modals';
import styles from './filterDateTimeRangePicker.style';

const FilterDateTimeRangePicker = ({
  value = [null, null],
  error,
  onChange,
  label,
  ...rest
}) => {
  const convertedValue = [
    value[0] ? parseISO(value[0]) : null,
    value[1] ? parseISO(value[1]) : null,
  ];

  return (
    <Box sx={styles.container}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
        <DateTimeRangePicker
          value={convertedValue}
          onChange={onChange}
          slotProps={{
            popper: {
              sx: styles.popper,
            },
            textField: ({ position }) => ({
              variant: 'outlined',
              sx: styles.textfield,
              label: label
                ? `${label} ${position === 'start' ? 'from' : 'to'}`
                : undefined,
            }),
          }}
          views={['day', 'hours', 'minutes']}
          ampm={false}
          format="dd/MM/yyyy HH:mm"
          calendars={1}
          {...rest}
        />
      </LocalizationProvider>

      <Tooltip title="Clear dates">
        <CloseIcon
          data-testid="CloseIcon"
          onClick={() => onChange([null, null])}
          sx={{
            ...styles.clearIcon,
            visibility: value[0] || value[1] ? 'visible' : 'hidden',
          }}
        />
      </Tooltip>
    </Box>
  );
};

export default FilterDateTimeRangePicker;
